import * as React from "react"
const SvgBag = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22.428q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 20.428v-12q0-.824.587-1.412A1.93 1.93 0 0 1 5 6.429h2q0-2.076 1.463-3.538Q9.925 1.429 12 1.429c2.075 0 2.563.487 3.537 1.462Q17 4.353 17 6.429h2q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.587zm0-2h14v-12H5zm4-14h6q0-1.25-.875-2.124A2.9 2.9 0 0 0 12 3.429a2.9 2.9 0 0 0-2.125.875A2.9 2.9 0 0 0 9 6.429Zm2.975 8q1.85 0 3.35-1.225 1.5-1.224 1.475-2.75 0-.424-.275-.724a.9.9 0 0 0-.7-.3.96.96 0 0 0-.625.225q-.275.224-.4.675a2.78 2.78 0 0 1-1.075 1.524 2.93 2.93 0 0 1-1.75.575 3 3 0 0 1-1.762-.575A2.64 2.64 0 0 1 9.15 10.33q-.124-.475-.375-.688a.9.9 0 0 0-.6-.212.95.95 0 0 0-.713.3 1 1 0 0 0-.287.725q0 1.524 1.475 2.75 1.475 1.224 3.325 1.224Z" />
  </svg>
)
export default SvgBag
